export default __webpack_public_path__ + "static/night-a296b33c3b568c0d6260f00b24a75916.png";